class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    if (this.matches('header-menu')) {
      this.addEventListener('pointerenter', this.onPointerEnter.bind(this));
      this.addEventListener('pointerleave', this.onPointerLeave.bind(this));
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  isDesktopHeaderMenu() {
    return this.matches('header-menu') && window.matchMedia('(min-width: 990px)').matches;
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onPointerEnter(event) {
    if (!this.isDesktopHeaderMenu() || event.pointerType === 'touch') return;
    this.open();
  }

  onPointerLeave(event) {
    if (!this.isDesktopHeaderMenu() || event.pointerType === 'touch') return;

    const activeElement = document.activeElement;
    if (
      activeElement &&
      activeElement !== this.mainDetailsToggle.querySelector('summary') &&
      this.contains(activeElement)
    )
      return;
    this.close();
  }

  onSummaryClick(event) {
    // A mouse click should behave like hover on desktop; keyboard activation keeps native details behavior.
    if (!this.isDesktopHeaderMenu() || event.detail === 0) return;
    event.preventDefault();
    this.open();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
